<template>
  <CRow class="main py-5 mt-3">
    <CCol sm="8" class="py-5">
      <CRow>
        <CCol sm="12" class="d-flex flex-column">
          <div>
            <h2 class="titlePage font-weight-normal text-capitalize pb-4">
              {{ $t('sender.smsSender.newSender-pageTitle') }}
            </h2>
          </div>
        </CCol>
      </CRow>
      <CRow class="mt-2">
        <CCol>
          <div class="d-flex justify-content-between border-b">
            <h3 class="font-weight-normal text-capitalize">{{ $t('sender.smsSender.newSender-text2') }}</h3>
            <CButton @click="$router.go(-1)" class="bg-gray-200 px-4 py-2"> {{ $t('sender.smsSender.newSender-btn-cancel') }}</CButton>
          </div>
          <div class="my-4">
            <p class="p-0">
              {{ $t('sender.smsSender.newSender-text3') }}
            </p>
          </div>
          <CForm class="my-4">
            <div v-for="(item, index) in options" :key="index">
              <CInputRadio
                name="typeInput"
                id=""
                color="primary"
                addLabelClasses="h4 font-weight-normal text-capitalize"
                :label="item.label"
                custom
                :value="item.value"
                @update:checked="getValue"
              />
              <p>
                {{ item.props.description }}
              </p>
            </div>
          </CForm>
          <div class="my-5">
            <h4 class="font-weight-normal text-capitalize mb-2">
              {{ $t('sender.smsSender.newSender-simpleTitle') }}
            </h4>
            <CForm @submit.prevent>
              <div class="form-group" v-if="'Number' == optionSelectType" style="max-width: 300px">
                <masked-input
                  type="tel"
                  name="phone"
                  class="form-control my-4"
                  minlength="9"
                  :mask="['+', /[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]"
                  :guide="true"
                  placeholderChar=" "
                  :placeholder="$t('sender.smsSender.newSender-placeholder-newSenderAlpha')"
                  v-model="senderPhone"
                />
              </div>

              <div v-else class="form-group" style="max-width: 300px">
                <input
                  class="form-control my-4"
                  type="text"
                  v-mask="'YYYYYYYYYYY'"
                  v-model="senderName"
                  :placeholder="$t('sender.smsSender.newSender-placeholder-newSenderNumber')"
                />
              </div>
              <div class="d-flex align-items-center">
                <div class="inputUpload">
                  <CIcon name="upload" :height="18" class="px-3 text-gray-700" viewBox="0 0 32 32" />
                  <CInputFile
                    name="uploadfile"
                    class="text-uppercase"
                    :label="$t('sender.smsSender.newSender-placeholder-updateFile')"
                    @change="getfile"
                  />
                </div>
                <div class="m-0 px-2 font-sm inputUpload__nameFile" v-if="file.name">
                  File name: <b class="text-secondar mx-1">{{ file.name }}</b>
                  <CButton @click="clearUpload('file')" style="width: 50px">
                    <CIcon name="refused" :height="18" class="text-gray-700" viewBox="0 0 32 32" />
                  </CButton>
                </div>
              </div>
              <transition name="fade">
                <MenssageAlert class="mt-3 w-100" :messages="messagesFile" />
              </transition>
            </CForm>
            <p class="mt-4">
              {{ $t('sender.smsSender.newSender-text4') }}
            </p>
          </div>
          <div class="my-5">
            <h4 class="font-weight-normal text-capitalize my-2">
              {{ $t('sender.smsSender.newSender-titleRules') }}
            </h4>
            <p>
              {{ $t('sender.smsSender.newSender-text5') }}
            </p>

            <p>
              {{ $t('sender.smsSender.newSender-text6') }}
            </p>
          </div>
          <div class="fd-flex finishArea">
            <CInputCheckbox
              :checked="accept"
              @update:checked="(value) => (accept = value)"
              custom
              :label="$t('sender.smsSender.newSender-label-terms')"
            />

            <div v-if="loading" class="d-flex">
              <CSpinner class="my-3" color="primary" />
            </div>
            <CButton v-else :disabled="!isValid" color="primary" @click="sendSender" class="mt-4 text-uppercase px-3 mb-5">
              {{ $t('sender.smsSender.newSender-btn-submit') }}
            </CButton>
          </div>
          <transition name="fade">
            <MenssageAlert :messages="messages" />
          </transition>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
import MaskedInput from 'vue-text-mask'
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'
import VueMask from 'v-mask'

const LIMITE_SIZE = 5

const TYPES_FILE = [
  'image/png',
  'image/jpeg',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
]

export default {
  name: 'SendersSMS',
  components: {
    MaskedInput,
    MenssageAlert,
    VueMask,
  },
  data() {
    return {
      myInputModel: '',
      loading: false,
      messages: [],
      messagesFile: [],
      senderPhone: '',
      senderName: '',
      optionSelectType: null,
      accept: false,
      fileisValid: false,
      file: {},
      options: [
        {
          value: 'String',
          label: this.$t('sender.smsSender.options-alpha'),
          props: {
            description: this.$t('sender.smsSender.options-alpha-description'),
          },
        },
        {
          value: 'Number',
          label: this.$t('sender.smsSender.options-numeric'),
          props: {
            description: this.$t('sender.smsSender.options-numeric-description'),
          },
        },
      ],
    }
  },
  computed: {
    isValid() {
      return this.accept && this.fileisValid && (this.senderPhone.trim().length >= 9 || this.senderName.length > 0)
    },
  },
  methods: {
    getValue(value, event) {
      this.senderPhone = ''
      this.senderName = ''
      this.optionSelectType = event.target.defaultValue
    },

    clearUpload(field) {
      this[`${field}FileName`] = ''
      this[field] = {}
    },

    getfile(file) {
      this.messagesFile = []
      this.file = {}
      if (this.verifyTypeFile(file)) this.file = file[0]
    },

    bytesToSize(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes == 0) return '0 Byte'
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
      return {
        size: (bytes / (1024 * 1024)).toFixed(2), // to MB
        FormatValue: Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i],
      }
    },

    verifyTypeFile(file) {
      // tamanho
      if (this.bytesToSize(file[0].size).size > LIMITE_SIZE) {
        this.messagesFile.push({
          status: 'danger',
          text: this.$t('sender.smsSender.error-limiteSize', LIMITE_SIZE),
        })

        return (this.fileisValid = false)
      }

      // tipos de files
      if (!TYPES_FILE.includes(file[0].type)) {
        this.messagesFile.push({
          status: 'danger',
          text: this.$t('sender.smsSender.error-typeFiles'),
        })

        return (this.fileisValid = false)
      }

      return (this.fileisValid = true)
    },

    blobFile() {
      let file = new FormData()

      try {
        file.append('File', this.file)
        file.append('Sender', this.senderPhone || this.senderName)
      } catch (error) {
        console.log(error)
      }

      return file
    },

    sendSender() {
      const FILE = this.blobFile()
      this.messages = []
      this.loading = true
      let organizationId = this.$store.state.auth.organizationId

      services
        .createSenderSMS(organizationId, FILE)
        .then((response) => {
          this.messages.push({
            status: 'success',
            text: response.data.message || this.$t('sender.smsSender.success'),
          })

          setTimeout(() => {
            this.$router.push({ name: 'senders-sms' })
          }, 1500)

          this.clean()
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message || 'Erro',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    clean() {
      this.accept = false
      this.senderPhone = ''
      this.senderName = ''
      this.file = {}
    },
  },
}
</script>

<style lang="scss" scoped>
p {
  color: var(--gray-600);
}

.border-b {
  padding-bottom: 0.6rem;
  border-bottom: 1px solid var(--gray-500);
}
</style>

<style lang="scss">
.finishArea {
  .custom-control-label {
    padding-top: 5px;
    padding-left: 5px;
    color: var(--gray-600);
  }
}
</style>
